
<h1 class="text-center text-white mt-5">Registeration Form</h1>
<form [formGroup]="signupForm" class="w-50 m-auto py-5" (ngSubmit)="signUp()">
   
    <div class="form-group">
      <label class="text-white" for="">First Name</label>
      <input formControlName="first_name" type="text" class="form-control">
      <div *ngIf="signupForm.controls.first_name.invalid&&signupForm.controls.first_name.touched" class="alert alert-danger mt-2">first name not valid</div>
    </div>
    <div class="form-group">
        <label class="text-white" for="">Last Name</label>
        <input formControlName="last_name" type="text" class="form-control">
        <div *ngIf="signupForm.controls.last_name.invalid&&signupForm.controls.last_name.touched" class="alert alert-danger mt-2">last name not valid</div>

      </div>
      <div class="form-group">
        <label class="text-white" for="">Age</label>
        <input formControlName="age" type="number" class="form-control">
        <div *ngIf="signupForm.controls.age.invalid&&signupForm.controls.age.touched" class="alert alert-danger mt-2">age not valid</div>

      </div>
      <div class="form-group">
        <label class="text-white" for="">Email</label>
        <input formControlName="email" type="text" class="form-control">
        <div *ngIf="signupForm.controls.email.invalid&&signupForm.controls.email.touched" class="alert alert-danger mt-2">email not valid</div>

      </div>
      <div class="form-group">
        <label class="text-white" for="">Password</label>
        <input formControlName="password" type="password" class="form-control">
        <div *ngIf="signupForm.controls.password.invalid&&signupForm.controls.password.touched" class="alert alert-danger mt-2">password not valid</div>

      </div>

      <button [disabled]="signupForm.invalid" class="btn btn-primary float-right" type="submit">Register</button>

</form>
